const getLeafFieldNamesFromStructure = (fieldStructure) => {
  if (!fieldStructure) {
    return [];
  }

  return Object.entries(fieldStructure)
    .filter(([, definition]) => !definition?.fields)
    .map(([fieldName]) => fieldName);
};

export default getLeafFieldNamesFromStructure;
